import React from "react";

export default function AppFooter() {
  return (
    <footer className="border-t border-ink-200 bg-white">
      <div className="mx-auto max-w-[1600px] px-4 py-6 sm:px-6 lg:px-8">
        <p className="max-w-reading text-xs leading-relaxed text-ink-600">
          Register data comes from the EUIPO Trademark Search API and TMview. Similarity scores are
          automated estimates produced by a language model. Neither is legal advice — have a
          trademark attorney run a full clearance search before you file.
        </p>
      </div>
    </footer>
  );
}
